import { makeGetRequest } from "./apiRequest";
import { WEIGHT_RANGES_URL } from "./conf";


export async function listWeightRanges(params) {
  return await makeGetRequest(WEIGHT_RANGES_URL, params);
}